// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const VisitorsAnalytics: React.FC = () => {
  const {
    data: { visitorsAnalytics },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const { labelsNames, chartData } = useDatesChartData(mode, visitorsAnalytics, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="darkblue"
        title="Track Visitors"
        subtitle="Amount track visitors added manually."
        label="Sessions"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
